const Mo3tiStatCard = ({
  icon: Icon,
  value,
  label,
  color = "#2e7cba",
  trend,
  subtitle,
  theme,
  isRTL,
}) => (
  <div
    style={{
      background: theme === "dark" ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
      borderRadius: "1rem",
      padding: "1.55rem",
      border: theme === "dark"
        ? "1px solid rgba(255,255,255,0.15)"
        : "1px solid rgba(0,0,0,0.05)",
      boxShadow: theme === "dark"
        ? "0 0.5rem 2rem rgba(0,0,0,0.3), inset 0 0.0625rem 0 rgba(255,255,255,0.1)"
        : "0 0.5rem 2rem rgba(0,0,0,0.1)",
      WebkitBackdropFilter: theme === "dark" ? "blur(25px) saturate(180%)" : "blur(10px)",
      transition: "all 0.3s ease",
      cursor: "pointer",
      direction: "ltr",
      textAlign: isRTL ? "right" : "left",
    }}
    className="hover-card"
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "16px",
        flexDirection: isRTL ? "row-reverse" : "row",
      }}
    >
      <div
        style={{
          width: "clamp(36px, 5vw, 44px)",
          height: "clamp(36px, 5vw, 44px)",
          background: `${color}20`,
          borderRadius: "12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color,
        }}
      >
        {Icon && <Icon size={24} />}
      </div>
      <span
        style={{
          color,
          fontSize: "clamp(12px, 1.5vw, 14px)",
          fontWeight: "600",
        }}
      >
        {trend}
      </span>
    </div>
    <p
      style={{
        color,
        fontSize: "clamp(24px, 4vw, 32px)",
        fontWeight: "800",
        margin: "clamp(8px, 1.5vw, 12px) 0",
      }}
    >
      {value}
    </p>
    <p
      style={{
        color: theme === "dark" ? "rgba(255,255,255,0.9)" : "rgba(26,26,26,0.7)",
        fontSize: "clamp(13px, 1.8vw, 15px)",
        fontWeight: "600",
        margin: "0 0 4px 0",
      }}
    >
      {label}
    </p>
    <p
      style={{
        color: theme === "dark" ? "rgba(255,255,255,0.7)" : "rgba(26,26,26,0.6)",
        fontSize: "clamp(12px, 1.5vw, 14px)",
        margin: 0,
      }}
    >
      {subtitle}
    </p>
  </div>
);

export default Mo3tiStatCard;
